import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FlowCompleteRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FlowCompleteResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const flowComplete = (request: FlowCompleteRequest, options?: CashRequestOptions) =>
  post<FlowCompleteRequest, FlowCompleteResponse>('/2.0/cash/flow-complete', request, {
    ...options,
    rejectOnError: true,
  })
